// extracted by mini-css-extract-plugin
export default {"content":"Content_content__D1BmO","underline":"Content_underline__1gOM7"};